// https://companywelfaresvil.poste.it/shopping/staticapi/v1/orders/1204462b-fd00-48bf-aaf0-8fcbbff08583
import type { refundApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

const apiBaseUrl = './refund/api/v1'

export const deleteRefund = http.delete<refundApi.RefundRequestDeletePathParams, object, undefined>(
  apiBaseUrl + '/refunds/:refundId',
  async ({ params }) => {
    if (params.refundId === 'FAILED') {
      return HttpResponse.text(undefined, { status: 400 })
    } else {
      return HttpResponse.text(undefined, { status: 204 })
    }
  },
)
